$(window).on('scroll', function() {
    let header = $('header');
    if ($(this).scrollTop() > 200) {
        if (!header.hasClass("sticky-top")) {
            header.addClass("sticky-top");
        }
    } else {
        if (header.hasClass("sticky-top")) {
            header.removeClass("sticky-top");
        }
    }
});